import React from 'react';
import CenterSpinner from '../../../../general/Loadings/CenterSpinner';
import PropTypes from 'prop-types';

const CreateNewReport = React.lazy(() => import('./CreateNewReport'));
const EditReport = React.lazy(() => import('./EditReport'));

const CustomReports = ({ id }) => {
     return (
          <div className='rule-detail'>
               <React.Suspense fallback={<CenterSpinner />}>{id ? <EditReport id={id} /> : <CreateNewReport />}</React.Suspense>
          </div>
     );
};


CustomReports.propTypes = {
     id: PropTypes.string,
};

export default CustomReports;
